import { render } from "./CommodityStockDialog.vue?vue&type=template&id=d4885ce6&scoped=true"
import script from "./CommodityStockDialog.vue?vue&type=script&lang=js"
export * from "./CommodityStockDialog.vue?vue&type=script&lang=js"

import "./CommodityStockDialog.vue?vue&type=style&index=0&id=d4885ce6&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4885ce6"]])

export default __exports__